<template>
  <Chart type="line" :height="height" :data="data" :options="options" />
</template>

<script>
import { defineComponent, computed } from 'vue'
import moment from 'moment-timezone'
export default defineComponent({
  props: {
    height: {
      type: Number,
      default: 0
    },
    results: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const data = computed(() => {
      return {
        labels: props.results
          .filter((data) => data.peso)
          .map((result) => moment.utc(result.day).format('DD-MM')),
        datasets: [
          {
            data: props.results
              .map((result) => Number(result.peso) || 0)
              .filter((data) => data),
            backgroundColor: 'transparent',
            borderColor: '#FDAE00',
            pointBackgroundColor: 'black',
            pointRadius: 3
          }
        ]
      }
    })
    const options = computed(() => {
      return {
        responsive: true,
        legend: {
          display: false
        },
        elements: {
          line: {
            tension: 0.4
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                suggestedMin: 0,
                beginAtZero: 0,
                fontSize: '12',
                fontColor: '#777777'
              }
            }
          ]
        }
      }
    })

    return {
      data,
      options
    }
  }
})
</script>
